import CommonTable from "utilFunctions/shared/CommonTable/CommonTable";
interface FacultiesBranchesIC {
  loader: boolean;
  data: any[];
  tableHeading: any;
  sortColumn: string;
  sortOrder: string;
  setSortColumn: any;
  setSortOrder: any;
  screen: any;
  regionId: any;
  streamId: any;
}
const FacultiesBranches = ({
  loader,
  data,
  tableHeading,
  sortColumn,
  sortOrder,
  setSortColumn,
  setSortOrder,
  screen,
  regionId,
  streamId,
}: FacultiesBranchesIC) => {
  console.log("checking branch data", data);
  const extraInformation = {
    branchAndRegionIdentifier: false,
    regionId: regionId,
    streamId: streamId,
  };
  return (
    <>
      <CommonTable
        mode="studentHome"
        isTableLoader={loader}
        tableData={data}
        tableHeading={tableHeading}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        primaryMessage="Branch data not available"
        secondaryMessage=""
        className={
          ["xs", "sm", "md"].includes(screen) ? "facultyDivMB" : "feedbackTable"
        }
        sortingArray={[
          "unmarkedLectureCount",
          "overallRatingAvg",
          "numberOfFeedbacks",
          "totalFacultiesCount",
        ]}
        extraInformation={extraInformation}
      />
    </>
  );
};
export default FacultiesBranches;
